import axios from "axios";
import BaseApiService from "@/api/BaseApiService";

export default class AuthService extends BaseApiService {
  getUserToken(oneTimeToken: string) {
    const url = this.getProjectCostsApiUrl("/auth/check-ott-token");
    return this.processRequest(axios.post(url, { ott: oneTimeToken }));
  }

  checkLogin() {
    const url = this.getProjectCostsApiUrl("/auth/check-login");
    return this.processRequest(axios.get(url));
  }

  /**
   * Get current user information including permissions
   */
  getUserInfo() {
    const url = this.getApiUrl("/auth/user-data");
    return this.processRequest(axios.get(url));
  }
}
